function showColorSelector(event) {
  var colorInputElement = event.target;
  var paletteColor = null;
  var color = null;
  if (colorInputElement) {
  	paletteColor = colorInputElement.getAttribute("data-palette-color");
  	color = colorInputElement.getAttribute("data-color");
  }
  
  document.getElementById("color-selector_overlay").style.display = "block";
  var json = $(".color-selector").data("colors-json");
  $.getJSON(json, function(data, status, xhr) {
    if (status === "success") {
      $(".color-selector_palette").append(buildPalette(data, paletteColor, color));
    }
  });  
}

function hideColorSelector() {
  document.getElementById("color-selector_overlay").style.display = "none";
  $(".color-selector_palette").empty();
}

function selectPalette(paletteColor, activeColor = null) {
  var colorElement = document.querySelector("[data-palette='" + paletteColor + "']");  
  document.querySelectorAll('.color-selector_color-palette').forEach(el => el.classList.remove('active-color'))
  
  if (colorElement) {
    colorElement.classList.add("active-color");
  }
  
  buildColors(paletteColor, activeColor);
}


/** 
 * Cleans up the color input by removing the selected color.
 */
function removeColor(event) {
  event.stopPropagation();
  document.getElementById("colorValue").value = "Бял";
  var colorInputElement = document.getElementById("color-selector-input");
  colorInputElement.classList.remove("color-selected");
  colorInputElement.style["background-color"] = "white";
  delete colorInputElement.dataset.paletteColor;
  delete colorInputElement.dataset.color;

  // Show the color icon.
  var colorInputIcon = document.getElementById("color-selector-icon");
  if (colorInputIcon) {
  	colorInputIcon.style.display = "block";
  }

  // Update the main text.
  var colorInputText = document.getElementById("color-selector-main-text");
  if (colorInputText) {
  	colorInputText.innerHTML = "Създай си цвят";
  }

  // Hide the clear text.
  var colorInputClear = document.getElementById("color-selector-clear");
  if (colorInputClear) {
  	colorInputClear.style.display = "none";
  }

}

/** 
 * Updates the color input with a given color.
 */
function setColor(paletteColor, colorTitle, colorHex) {
  document.getElementById("colorValue").value = colorTitle;
  var colorInputElement = document.getElementById("color-selector-input");
  colorInputElement.classList.add("color-selected");
  colorInputElement.style["background-color"] = colorHex;
  colorInputElement.dataset.paletteColor = paletteColor
  colorInputElement.dataset.color = colorHex

  // Hide the color icon.
  var colorInputIcon = document.getElementById("color-selector-icon");
  if (colorInputIcon) {
  	colorInputIcon.style.display = "none";
  }

  // Set the color name.
  var colorInputText = document.getElementById("color-selector-main-text");
  if (colorInputText) {
  	colorInputText.innerHTML = colorTitle;
  }

  // Show the clear text.
  var colorInputClear = document.getElementById("color-selector-clear");
  if (colorInputClear) {
  	colorInputClear.style.display = "block";
  }
}

function selectColor(paletteColor, colorTitle, colorHex) {
  hideColorSelector();
  setColor(paletteColor, colorTitle, colorHex);
}

function buildPalette(data, paletteColor = null, activeColor = null) {
  var firstColor = null;
  var $colors = [];
  for (var color in data) {
    if (data.hasOwnProperty(color)) {

      var colorPalette = data[color];
      if (colorPalette.hasOwnProperty("hex") && colorPalette.hasOwnProperty("colors")) {
        var hex = colorPalette.hex;
        var colors = colorPalette.colors;

        $colors.push($('<div class="color-selector_color-palette color-box" style="background-color: ' + hex + '" data-palette="' + color + '" data-palette-color="' + hex + '" onclick=selectPalette(\'' + color + '\')>'));
        // Build the colors for the first palette.
        if ($colors.length === 1) {
          firstColor = color;
        }
      }

    }
  }
  
  // The color palette is not shown when there's only one
  // palette and it is called: "_all";
  var appendPalette = !(Object.keys(data).length === 1 && data.hasOwnProperty('_all'));
  if (appendPalette) {
    $(".color-selector_palette").append($colors);
	$(".color-selector_palette").css({'height': '100px'});
  }

  var activePaletteColor = paletteColor ? paletteColor : firstColor;
  if (activePaletteColor) {
    selectPalette(activePaletteColor, activeColor);
  }
}

function buildColors(paletteColor, activeColor = null) {
  var json = $(".color-selector").data("colors-json");
  $.getJSON(json, function(data, status, xhr) {
    if (status === "success") {
	  $(".color-selector_palette_colors").empty();
      var $colors = [];
      if (data.hasOwnProperty(paletteColor)) {
        var colors = data[paletteColor].hasOwnProperty("colors") ? data[paletteColor].colors : [];
        for (var index in colors) {
          if (colors.hasOwnProperty(index)) {
			var color = colors[index];
            if (color.hasOwnProperty("hex") && color.hasOwnProperty("title")) {
              var hex = color.hex;
              var title = color.title;
              var classes = "color-selector_color color-box";
              if (hex === activeColor) {
              	classes += " active-color";
              }
              
              $colors.push($('<div class="' + classes + '" style="background-color: ' + hex + '" data-color-title="' + title + '" onclick=\'selectColor("' + paletteColor + '", "' + title + '", "' + hex + '")\'>' + title + '</div>'));
            }
          }
        }
      }
      
      $(".color-selector_palette_colors").append($colors);
    }
  });  
}